import { Typography } from "@mui/material";

interface LabelProps {
  label: string;
  required?: boolean;
  size?: string;
  margin?: string;
}

const Label: React.FC<LabelProps> = ({ label, required, size, margin }) => {
  return (
    <Typography
      variant="h5"
      sx={{
        fontWeight: "bold",
        marginTop: margin || "10px",
        ...(size && { fontSize: size }),
      }}
    >
      {label} {required ? "*" : ""}
    </Typography>
  );
};

export default Label;
